import React from 'react';

import GroupTypeChip from 'components/Chips/GroupTypeChip';

import { MembershipMode } from 'utils/api/modules/memberGroups';

import { StyledMenuItem, StyledSelect } from '../styles';
import { GroupTypeSelectProps } from './types';

const OPTIONS: MembershipMode[] = [MembershipMode.Manual, MembershipMode.Dynamic];

const GroupTypeSelect: React.FunctionComponent<GroupTypeSelectProps> = ({ onChange, ...props }) => (
  <StyledSelect {...props} fullWidth onChange={(event) => onChange(event.target.value as MembershipMode)}>
    {OPTIONS.map((mode) => (
      <StyledMenuItem key={mode} value={mode}>
        <GroupTypeChip type={mode} />
      </StyledMenuItem>
    ))}
  </StyledSelect>
);

export default GroupTypeSelect;
